import { api } from './authService';

const pointsService = {
  getPoints: () => {
    return api.get('/points');
  },

  getPointHistory: () => {
    return api.get('/points/history');
  },

  updatePoints: (userId, amount, reason) => {
    return api.post('/points/update', { userId, amount, reason });
  },

  applyCoupon: (code) => {
    return api.post('/points/coupon', { code });
  },

  createCoupon: (couponData) => {
    return api.post('/points/coupon/create', couponData);
  },

  getCoupons: () => {
    return api.get('/points/coupons');
  },

  getStats: () => {
    return api.get('/points/stats');
  },

  getUsers: () => {
    return api.get('/points/users');
  }
};

export default pointsService;
